<template>
  <div>
    <div
      key="0"
      class="row table-title-row d-flex justify-content-between"
    >
      <div class="col-2 label">
        {{ $t('view-Payments.list.id') }}
      </div>
      <div class="col-3 label">
        {{ $t('view-Payments.list.date') }}
      </div>
      <div class="col-3 label">
        {{ $t('view-Payments.list.influencer') }}
      </div>
      <div class="col-3 label">
        {{ $t('view-Payments.list.campaign') }}
      </div>
      <div class="col-3 label">
        {{ $t('view-Payments.list.type') }}
      </div>
      <div class="col-2 label">
        {{ $t('view-Payments.list.amount') }}
      </div>
      <div class="col-3 label">
        {{ $t('view-Payments.list.status') }}
      </div>
    </div>
    <transition-group
      name="fade"
      tag="div"
      class="table-content"
    >
      <div
        v-for="item in list"
        :key="item.id"
        class="row d-flex justify-content-between"
      >
        <div class="col-2 item">
          #{{ item.id }}
        </div>
        <div class="col-3 item">
          <span>
            {{ $dateString(item.created_at)[0].replace(/\./g, '/') }}<br>
            <small>{{ $dateString(item.created_at)[1] }}</small>
          </span>
        </div>
        <div class="col-3 item justify-content-center text-center">
          <span v-if="item.taker && item.taker.influencer">
            <div
              v-lazy-container="{ selector: 'img', loading: emptyAvatar, error: emptyAvatar }"
              class="avatar mb-1"
            >
              <img :data-src="item.taker.avatar">
            </div>
            {{ item.taker.influencer.fullName }}<br>
            #{{ item.taker.name }}
          </span>
          <span v-else>
            ---
          </span>
        </div>
        <div class="col-3 item">
          {{ item.campaign ? item.campaign.name : item.campaign_cpc ? item.campaign_cpc.name : '---' }}
        </div>
        <div class="col-3 item">
          {{ $t('payment.type.' + item.type) }}
        </div>
        <div class="col-2 item">
          {{ item.price }} {{ $currencySymbol(item.currency) }}
        </div>
        <div class="col-3 item flex-wrap">
          <status-label :status="item.status" />
          <a
            v-if="showPayButton(item)"
            class="pay-button mt-2 text-center"
            @click="payHandler(item)"
          >
            <b-spinner
              v-if="buttonLoader"
              small
              label="small spinner"
            />
            <span v-else>
              {{ $t('view-Payments.pay') }}
            </span>
          </a>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
import statusLabel from './StatusLabel'

export default {
  components: {
    'status-label': statusLabel
  },
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      buttonLoader: false
    }
  },
  computed: {
    emptyAvatar () {
      return `${this.$publicPath}img/profile/empty_avatar.jpg`
    }
  },
  mounted () {
    const stripeScript = document.createElement('script')
    stripeScript.setAttribute('src', 'https://js.stripe.com/v3/')
    document.head.appendChild(stripeScript)
  },
  methods: {
    showPayButton (item) {
      return item.status === 'new' && item.type === 'campaign'
    },
    payHandler (item) {
      if (this.buttonLoader) {
        return
      }

      this.buttonLoader = true
      this.$store.dispatch('payments/pay', item.id)
        .then(result => {
          const apiKey = process.env.VUE_APP_STRIPE_PUB_API_KEY
          const stripe = new window.Stripe(apiKey)
          stripe.redirectToCheckout({ sessionId: result.stripe_session_id }).catch(e => { throw (e) })
          this.buttonLoader = false
        })
        .catch(e => {
          this.buttonLoader = false
          this.$flash.error(this.$t('view-Payments.pay.message.error'))
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .pay-button {
    border: 2px solid $warning;
    background-color: white;
    border-radius: 5px;
    padding: 0.5rem auto;
    display: block;
    width: 100%;
    font-weight: 600;
    &:hover {
      background-color: $warning;
      color: white;
      text-decoration: none;
    }
  }
</style>
